import consumer from "./consumer"

let connectionSubscription;
document.addEventListener("DOMContentLoaded", () => {
    const userId = parseInt(document.querySelector("meta[name='current-user-id']").content)

    connectionSubscription = consumer.subscriptions.create(
        { channel: "ConnectionsChannel", user_id: userId },
        {
            connected() {
                console.log("Conectado al ConnectionChannel");
                this.pingInterval = setInterval(() => {
                    this.perform("ping", { data: "ping"});
                }, 10000);
            },

            disconnected() {
                console.log("Desconectado del ConnectionChannel");
                clearInterval(this.pingInterval);
                consumer.subscriptions.remove(connectionSubscription);
                consumer.disconnect();
            },

            received(data) {
                console.log("Datos recibidos:", data);
            }
        }
    );
});